import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PropertyClass {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/propertyClasses`, options);
  }
}

export default PropertyClass;
